<template>
    <div>
        <van-nav-bar
            title="我的券"
        />
        <van-tabs v-model="activate1" type="card" color="#488aff" style="width:100%;">

            <van-tab title="优惠券" name="conpon">
                <van-tabs v-model="activate" type="card" color="#488aff" style="width:100%;margin-top:2%;">
                    <van-tab title="未使用" name="use">
                        <coupon :params="{'status__in': '0'}"></coupon>
                    </van-tab>
                    <van-tab title="已使用" name="unuse">
                        <coupon :params="{'status__in': '1,3'}"></coupon>
                    </van-tab>
                    <van-tab title="已过期" name="expired">
                        <coupon :params="{'status__in': '2,4'}"></coupon>
                    </van-tab>
                </van-tabs>
            </van-tab>

            <van-tab title="兑换券" name="voucher">
                <van-tabs v-model="activate2" type="card" color="#488aff" style="width:100%;margin-top:2%;">
                    <van-tab title="未使用" name="use">
                        <voucher :params="{'status__in': '0'}"></voucher>
                    </van-tab>
                    <van-tab title="已使用" name="unuse">
                        <voucher :params="{'status__in': '1,3'}"></voucher>
                    </van-tab>
                    <van-tab title="已过期" name="expired">
                        <voucher :params="{'status__in': '2,4'}"></voucher>
                    </van-tab>
                </van-tabs>
            </van-tab>
        
        </van-tabs>
    </div>
</template>

<script>
import { NavBar, Button,  List,  Tab, Tabs } from 'vant'
import voucher from '@/view/user/components/voucher'
import coupon from '@/view/user/components/coupon'

export default {
    components: {
        [NavBar.name]: NavBar,
        [Button.name]: Button,
        [Tab.name]: Tab,
        [Tabs.name]: Tabs,
        [List.name]: List,
        coupon,
        voucher
    },
    data() {
        return {
            activate: 'use',
            activate2:'use',
            activate1: 'conpon'
        }
    },
    mounted() {
    },
    methods: {
    }
}
</script>

<style lang="less" scoped>
</style>